import { defineMessages } from 'react-intl';

export const ROLES = {
  admin: 'admin',
};

export const ROUTES = {
  home: '/',
  addService: '/add-service',
  editService: '/services/edit/:id',
  services: '/services',
  profile: '/profile',
  admin: '/admin',
  serviceDetails: '/services/:id',
  faq: '/faq',
  privacy: '/privacy',
  contact: '/contact',
  termsAndConditions: '/terms-and-conditions',
  notFound: '*',
};

export const COLLECTIONS = {
  listings: 'listings',
  users: 'users',
};

export const COLLECTIONS_QUERIES = {
  location: 'location',
  category: 'category',
  price: 'price',
  providerUuid: 'providerUuid',
  status: 'status',
};

export const categoryMessages = defineMessages({
  category1: {
    id: 'category.1',
    defaultMessage: 'Юридические услуги',
  },
  category10: {
    id: 'category.10',
    defaultMessage: 'Организация мероприятий',
  },
  category11: {
    id: 'category.11',
    defaultMessage: 'Кредиты и ипотека',
  },
  category12: {
    id: 'category.12',
    defaultMessage: 'Риэлторы',
  },
  category13: {
    id: 'category.13',
    defaultMessage: 'Бухгалтерские услуги, налоги',
  },
  category14: {
    id: 'category.14',
    defaultMessage: 'Страхование',
  },
  category15: {
    id: 'category.15',
    defaultMessage: 'Уход и помощь',
  },
  category16: {
    id: 'category.16',
    defaultMessage: 'Клининговые услуги',
  },
  category17: {
    id: 'category.17',
    defaultMessage: 'Прочее',
  },
  category18: {
    id: 'category.18',
    defaultMessage: 'Покупка и продажа бизнеса',
  },
  category19: {
    id: 'category.19',
    defaultMessage: 'IT, компьютерные услуги',
  },
  category2: {
    id: 'category.2',
    defaultMessage: 'Автоуслуги',
  },
  category20: {
    id: 'category.20',
    defaultMessage: 'Медиа, СМИ',
  },
  category3: {
    id: 'category.3',
    defaultMessage: 'Медицина',
  },
  category4: {
    id: 'category.4',
    defaultMessage: 'Красота и здоровье',
  },
  category5: {
    id: 'category.5',
    defaultMessage: 'Для детей',
  },
  category6: {
    id: 'category.6',
    defaultMessage: 'Дом и ремонт',
  },
  category7: {
    id: 'category.7',
    defaultMessage: 'Отдых и досуг',
  },
  category8: {
    id: 'category.8',
    defaultMessage: 'Образование и курсы',
  },
  category9: {
    id: 'category.9',
    defaultMessage: 'Магазины',
  },
  category0: {
    id: 'category.0',
    defaultMessage: 'Все услуги',
  },
});

export const CATEGORIES = [
  {
    id: '0',
    name: 'Все услуги',
    parentId: '',
  },
  {
    id: '1',
    name: 'Юридические услуги',
    parentId: '',
  },
  {
    id: '10',
    parentId: '',
    name: 'Организация мероприятий',
  },
  {
    id: '11',
    parentId: '',
    name: 'Кредиты и ипотека',
  },
  {
    id: '12',
    name: 'Риэлторы',
    parentId: '',
  },
  {
    id: '13',
    name: 'Бухгалтерские услуги, налоги',
    parentId: '',
  },
  {
    id: '14',
    parentId: '',
    name: 'Страхование',
  },
  {
    id: '15',
    parentId: '',
    name: 'Уход и помощь',
  },
  {
    id: '16',
    parentId: '',
    name: 'Клининговые услуги',
  },
  {
    id: '17',
    name: 'Прочее',
    parentId: '',
  },
  {
    id: '18',
    parentId: '',
    name: 'Покупка и продажа бизнеса',
  },
  {
    id: '19',
    parentId: '',
    name: 'IT, компьютерные услуги',
  },
  {
    id: '2',
    name: 'Автоуслуги',
    parentId: '',
  },
  {
    id: '20',
    parentId: '',
    name: 'Медиа, СМИ',
  },
  {
    id: '3',
    parentId: '',
    name: 'Медицина',
  },
  {
    id: '4',
    parentId: '',
    name: 'Красота и здоровье',
  },
  {
    id: '5',
    parentId: '',
    name: 'Для детей',
  },
  {
    id: '6',
    name: 'Дом и ремонт',
    parentId: '',
  },
  {
    id: '7',
    parentId: '',
    name: 'Отдых и досуг',
  },
  {
    id: '8',
    parentId: '',
    name: 'Образование и курсы',
  },
  {
    id: '9',
    name: 'Магазины',
    parentId: '',
  },
];

export const locationMessages = defineMessages({
  location0: { id: 'location.0', defaultMessage: 'Вся Румыния' },
  location1: { id: 'location.1', defaultMessage: 'Бухарест' },
  location2: { id: 'location.2', defaultMessage: 'Клуж-Напока' },
  location3: { id: 'location.3', defaultMessage: 'Тимишоара' },
  location4: { id: 'location.4', defaultMessage: 'Яссы' },
  location5: { id: 'location.5', defaultMessage: 'Констанца' },
  location6: { id: 'location.6', defaultMessage: 'Крайова' },
  location7: { id: 'location.7', defaultMessage: 'Брашов' },
  location8: { id: 'location.8', defaultMessage: 'Галац' },
  location9: { id: 'location.9', defaultMessage: 'Плоешти' },
  location10: { id: 'location.10', defaultMessage: 'Орадя' },
  location11: { id: 'location.11', defaultMessage: 'Бакэу' },
  location12: { id: 'location.12', defaultMessage: 'Арджеш' },
  location13: { id: 'location.13', defaultMessage: 'Сибиу' },
  location14: { id: 'location.14', defaultMessage: 'Тырговиште' },
  location15: { id: 'location.15', defaultMessage: 'Сату-Маре' },
  location16: { id: 'location.16', defaultMessage: 'Бая-Маре' },
  location17: { id: 'location.17', defaultMessage: 'Ботошани' },
  location18: { id: 'location.18', defaultMessage: 'Рымнику-Вылча' },
  location19: { id: 'location.19', defaultMessage: 'Сучава' },
  location20: { id: 'location.20', defaultMessage: 'Тулча' },
});

export const LOCATIONS = [
  { id: '0', name: 'Вся Румыния' },
  { id: '1', name: 'Бухарест' },
  { id: '2', name: 'Клуж-Напока' },
  { id: '3', name: 'Тимишоара' },
  { id: '4', name: 'Яссы' },
  { id: '5', name: 'Констанца' },
  { id: '6', name: 'Крайова' },
  { id: '7', name: 'Брашов' },
  { id: '8', name: 'Галац' },
  { id: '9', name: 'Плоешти' },
  { id: '10', name: 'Орадя' },
  { id: '11', name: 'Бакэу' },
  { id: '12', name: 'Арджеш' },
  { id: '13', name: 'Сибиу' },
  { id: '14', name: 'Тырговиште' },
  { id: '15', name: 'Сату-Маре' },
  { id: '16', name: 'Бая-Маре' },
  { id: '17', name: 'Ботошани' },
  { id: '18', name: 'Рымнику-Вылча' },
  { id: '19', name: 'Сучава' },
  { id: '20', name: 'Тулча' },
];

export const LISTING_ITEM_STATUSES = {
  active: 'active',
  awaitingApproval: 'awaitingApproval',
  paused: 'paused',
  rejected: 'rejected',
};

export const TABS = {
  SERVICES: 'services',
  SETTINGS: 'settings',
} as const;

export const LANGUAGE_STORAGE_KEY = 'novoservice-language';

export const SORT_OPTIONS = defineMessages({
  byRelevant: {
    id: 'sorting.byRelevant',
    defaultMessage: 'По релевантности',
  },
  fromCheapToExpensive: {
    id: 'sorting.fromCheapToExpensive',
    defaultMessage: 'Сначала дешевле',
  },
  fromExpensiveToCheap: {
    id: 'sorting.fromExpensiveToCheap',
    defaultMessage: 'Сначала дороже',
  },
});
